import React, { useEffect, useState } from 'react';
import './Schedule.css';

function Schedule() {
    const [currentDate, setCurrentDate] = useState(new Date());
    const [view, setView] = useState('Week');
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [events, setEvents] = useState([]);

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const response = await fetch('http://localhost:5000/api/Sport/GetAllSports');
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                const transformedEvents = transformDataToEvents(data);
                setEvents(transformedEvents);
            } catch (error) {
                console.error('Failed to fetch events:', error);
            }
        };

        fetchEvents();
    }, []);

    const transformDataToEvents = (data) => {
        return data.map(sport => ({
            title: sport.name,
            start: new Date(sport.date), // Assuming there's a `date` field in your data
            end: new Date(new Date(sport.date).getTime() + sport.duration * 60000), // Assuming duration is in minutes
            color: "bg-blue-200", // Placeholder for color
            borderColor: "border-blue-500" // Placeholder for border color
        }));
    };

    const goToPreviousWeek = () => {
        const newDate = new Date(currentDate);
        newDate.setDate(newDate.getDate() - 7);
        setCurrentDate(newDate);
    };

    const goToNextWeek = () => {
        const newDate = new Date(currentDate);
        newDate.setDate(newDate.getDate() + 7);
        setCurrentDate(newDate);
    };

    const goToToday = () => {
        setCurrentDate(new Date());
    };

    const formatDate = (date) => {
        const options = { month: 'long', day: 'numeric', year: 'numeric' };
        return date.toLocaleDateString(undefined, options);
    };

    const getWeekRange = (date) => {
        const startOfWeek = new Date(date);
        startOfWeek.setDate(date.getDate() - date.getDay() + 1);

        const endOfWeek = new Date(startOfWeek);
        endOfWeek.setDate(startOfWeek.getDate() + 6);

        return `${formatDate(startOfWeek)} - ${formatDate(endOfWeek)}`;
    };

    const getDayEvents = (day) => {
        return events.filter(
            (event) =>
                event.start.getFullYear() === day.getFullYear() &&
                event.start.getMonth() === day.getMonth() &&
                event.start.getDate() === day.getDate()
        );
    };

    const renderDayColumn = (day) => {
        const dayEvents = getDayEvents(day);
        return (
            <div className="relative w-1/8" key={day}>
                <div className="border-r border-t flex-1 relative">
                    {dayEvents.map((event) => (
                        <div
                            key={event.title}
                            className={`absolute m-1 p-1 rounded ${event.color} ${event.borderColor} border-2 cursor-pointer`}
                            style={{
                                top: `${(event.start.getHours() * 60 + event.start.getMinutes() - 420) / 2 + 2}px`,
                                height: `${(((event.end - event.start) / 60000) / 2) - 4}px`,
                                width: "90%", // Adjust width as needed
                            }}
                            onClick={() => handleEventClick(event)}
                        >
                            <span>{event.title}</span>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    const handleEventClick = (event) => {
        setSelectedEvent(event);
    };

    const closePopUp = () => {
        setSelectedEvent(null);
    };

    const renderHourRows = () => {
        const hours = [];
        for (let i = 7; i <= 22; i++) {
            hours.push(
                <div key={i} className="h-30 flex items-center justify-center border-b">
                    {i}:00
                </div>
            );
        }
        return hours;
    };

    const renderHourRowsFree = () => {
        const hours = [];
        for (let i = 7; i <= 22; i++) {
            hours.push(
                <div key={i} className="h-30 flex items-center justify-center border-b">
                    &nbsp;
                </div>
            );
        }
        return hours;
    };

    const daysOfWeek = [];
    const startOfWeek = new Date(currentDate);
    startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay() + 1);

    for (let i = 0; i < 7; i++) {
        const day = new Date(startOfWeek);
        day.setDate(startOfWeek.getDate() + i);
        daysOfWeek.push(day);
    }

    return (
        <div className="w-full">
            <div className="flex justify-between items-center bg-light-secondaryBackground dark:bg-dark-secondaryBackground p-4 shadow-element mb-4 rounded-card">
                <button
                    onClick={goToToday}
                    className="bg-light-accent dark:bg-dark-accent text-light-buttonFont dark:text-dark-buttonFont p-2 rounded-full shadow-element hover:shadow-element-hover active:shadow-element-active element-font"
                >
                    Today
                </button>
                <div className="flex items-center">
                    <button
                        onClick={goToPreviousWeek}
                        className="bg-light-accent dark:bg-dark-accent text-light-buttonFont dark:text-dark-buttonFont p-2 rounded-full shadow-element hover:shadow-element-hover active:shadow-element-active mr-2 w-10"
                    >
                        &lt;
                    </button>
                    <div className="text-lg font-semibold text-light-font dark:text-dark-font mx-4">
                        {getWeekRange(currentDate)}
                    </div>
                    <button
                        onClick={goToNextWeek}
                        className="bg-light-accent dark:bg-dark-accent text-light-buttonFont dark:text-dark-buttonFont p-2 rounded-full shadow-element hover:shadow-element-hover active:shadow-element-active ml-2 w-10"
                    >
                        &gt;
                    </button>
                </div>
                <div className="flex">
                    {['Year', 'Month', 'Week', 'Day'].map((v, index, arr) => (
                        <button
                            key={v}
                            onClick={() => setView(v)}
                            className={`${
                                view === v
                                    ? 'bg-light-accent text-light-buttonFont'
                                    : 'bg-light-secondaryBackground dark:bg-dark-secondaryBackground text-light-font dark:text-dark-font'
                            } p-2 hover:shadow-element-hover active:shadow-element-active element-font border-y-2 border-light-activeElement ${
                                index === 0 ? 'rounded-l-full border-2' : ''
                            } ${index === arr.length - 1 ? 'rounded-r-full border-2' : ''} ${
                                index > 0 && index < arr.length - 1 ? '' : ''
                            }`}
                        >
                            {v}
                        </button>
                    ))}
                </div>
            </div>
            <div className="w-full">
                <div className="grid grid-cols-8 gap-1">
                    <div className="h-12"></div>
                    {daysOfWeek.map((day) => (
                        <div className="flex items-center justify-center h-12 border-t border-r" key={day}>
                            {day.toLocaleDateString(undefined, { weekday: 'short', day: 'numeric' })}
                        </div>
                    ))}
                </div>
                <div className="grid grid-cols-8 gap-1">
                    <div className="flex flex-col items-center justify-start border-r">
                        {renderHourRows()}
                    </div>
                    {daysOfWeek.map((day) => (
                        <div className="relative w-full" key={day}>
                            {renderDayColumn(day)}
                            <div className="flex-1 border-t border-r h-full">
                                {renderHourRowsFree()}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            {selectedEvent && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                    <div className="bg-white dark:bg-dark-background p-8 rounded shadow-element">
                        <h2 className="title-font mb-4">You successfully signed on {selectedEvent.title}</h2>
                        <p className="element-font">We are waiting for you on {formatDate(selectedEvent.start)}</p>
                        <button
                            onClick={closePopUp}
                            className="bg-light-accent dark:bg-dark-accent text-light-buttonFont dark:text-dark-buttonFont p-2 rounded-full shadow-element hover:shadow-element-hover active:shadow-element-active mt-4"
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Schedule;
